// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__OQTQr","logo":"styles_logo__BYwP3","logoWrapper":"styles_logoWrapper__F3yhr","bold":"styles_bold__QjdWy","sidebar":"styles_sidebar__79Clg"};